<template>
  <div class="dashboard" v-if="readyGeo">
    <drawer />
    <Navbar />
    <v-content>
      <v-progress-linear
        v-if="!connected"
        color="primary"
        indeterminate
        rounded
        height="5"
      ></v-progress-linear>
      <v-alert
        text
        v-if="userMe.role == 1"
        prominent
        type="warning"
        icon="mdi-information"
      >
        {{ $t("admin") }}
      </v-alert>
      <v-alert
        text
        v-if="permission.paymentMessage"
        prominent
        type="error"
        icon="mdi-information"
      >
        {{ $t("bill") }} </v-alert
      ><v-alert
        text
        v-if="permission.isTrial"
        prominent
        type="warning"
        icon="mdi-information"
      >
        {{ $t("trial") }}
      </v-alert>
      <router-view />
    </v-content>
    <iframe id="printf" name="printf" style="display: none"></iframe>
    <transition name="fade-up" mode="out-in" v-if="showCookies == true">
      <div class="agree-privacy">
        <h1>{{ $t("cookie.title") }}</h1>
        <p>
          {{ $t("cookie.info") }}
          <a href="https://quickdeliverysystem.com/cookie/" target="blank">{{
            $t("cookie.read")
          }}</a>
        </p>
        <v-btn color="blue" @click="agree()" dark>{{ $t("cookie.btn") }}</v-btn>
      </div>
    </transition>
  </div>
  <div v-else>
    <vue-splash
      :show="!connected || !readyGeo"
      logo="/logo.png"
      :title="$t('splash')"
      color="#ff9800"
      :size="200"
      :fixed="false"
    /><br />
    <center>
      <v-progress-circular
        :size="75"
        color="primary"
        width="7"
        indeterminate
      ></v-progress-circular>
    </center>
  </div>
</template>

<script>
import Drawer from "@/views/core/Drawer.vue";
import Navbar from "@/views/core/Navbar.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import IPData from "ipdata";
const ipdata = new IPData(
  "0fe03e8e0126ce0edb63578e089532986649935d6941c9eb7b012472"
);
export default {
  components: { Drawer, Navbar },
  name: "dashboard",
  data() {
    return {
      showCookies: false,
    };
  },
  computed: {
    ...mapGetters("employees", ["employees"]),
    ...mapState(["readyGeo"]),
    ...mapState("IO", ["connected", "socket"]),
    ...mapState(["darkMode"]),
    ...mapState("users", ["permission", "userMe"]),
    mode() {
      return this.$store.getters["darkMode"];
    },
    logo() {
      return "<%= BASE_URL %>/../assets/logo.png";
    },
  },

  beforeCreate() {
    console.log("initialize");
    console.log("Quick services");
  },
  methods: {
    ...mapActions("employees", ["list"]),
    ...mapActions("IO", ["initSocket"]),
    ...mapActions("users", ["me"]),
    agree() {
      $cookies.set("agree", false);
      this.showCookies = false;
    },
  },
  mounted() {
    ipdata
      .lookup()
      .then(function (data) {
        $cookies.set("code", data.country_code);
        $cookies.set("country", data.country_name);
        $cookies.set("currency", data.currency.code);
        // console.log(data)
      })
      .catch((e) => {
        console.log(e);
      });
    navigator.geolocation.getCurrentPosition(
      function (location) {
        $cookies.set("lat", location.coords.latitude);
        $cookies.set("lng", location.coords.longitude);
      },
      (geoError) => {
        console.error(geoError);
      }
      // https://api.ipdata.co/?api-key=0fe03e8e0126ce0edb63578e089532986649935d6941c9eb7b012472
    );

    // this.$store.dispatch("packages/list");

    this.list();
    if (this.connected === false) {
      this.initSocket();
    }
    this.$store.dispatch("getGeoPlace");
    this.$store.dispatch("getPublicSRCPlace");
    if ($cookies.isKey("agree")) this.showCookies = $cookies.get("agree");
    else this.showCookies = true;
    if ($cookies.isKey("darkMode")) {
      this.$store.dispatch(
        "changeDarkMode",
        String($cookies.get("darkMode")) == "true"
      );
    } else this.$store.dispatch("changeDarkMode", String(this.mode) == "true");
    this.$vuetify.theme.dark = String(this.mode) == "true";
    //req to get employee locations

    setInterval(() => {
      for (let index = 0; index < this.employees.length; index++) {
        const element = this.employees[index];
        if (element.role == 2) {
          this.socket.emit("admin/geo", { id: element.id });
        }
      }
    }, 50000);
    this.me();
  },
};
</script>

<style lang="sass">

.agree-privacy
  position: fixed
  bottom: 0px
  width: 100%
  background: rgba(0,0,0,0.7)
  padding: 5px 20px
  box-sizing: bpackage-box
  text-align: center
  z-index: 999999
  h1
    margin-bottom: 5px
    margin-right: 20px

    color: rgba(230,230,230,1)
    font-size: 14px
  p
    margin-bottom: 5px
    margin-right: 20px
    display: inline-block
    color: rgba(230,230,230,1)
    font-size: 14px
    button
      display: inline-block
      font-size: 11px
.fade-up-enter-active
  transition: all .1s
  transition-delay: 1.5s
.fade-up-leave-active
  transition: all .1s
  transition-delay: 1.5s
.fade-up-enter
  transform: translateY(30px)
  opacity: 0
.fade-up-leave-to
  transform: translateY(30px)
  opacity: 0
</style>
